export default "__VITE_ASSET__DH3Sd$1i__"